import React from 'react';

interface UseAccordionScrollProps {
  isActive: boolean;
  htmlId: string;
  proposalType: 'v1' | 'v2';
  contentRef: React.RefObject<HTMLElement>;
  offset?: number;
}

export const useAccordionScroll = ({
  isActive,
  htmlId,
  contentRef,
  proposalType,
  offset = 200,
}: UseAccordionScrollProps) => {
  React.useEffect(() => {
    if (isActive && contentRef.current) {
      setTimeout(() => {
        const spoilerHeader = document.getElementById(htmlId);
        const container =
          proposalType === 'v2'
            ? document.querySelector('.landing-v2-custom-content')
            : document.getElementById('LANDING_PAGES_CONTAINER_ID');

        if (spoilerHeader && container) {
          const currentScrollTop = container.scrollTop;
          const containerRect = container.getBoundingClientRect();
          const spoilerRect = spoilerHeader.getBoundingClientRect();
          const relativeTop = spoilerRect.top - containerRect.top;

          const offsetPosition = currentScrollTop + relativeTop - offset;

          container.scrollTo({ top: offsetPosition, behavior: 'smooth' });
        }
      }, 50);
    }
  }, [isActive, htmlId, offset, contentRef]);
};
